/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { displayMessage, postAPI, getAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import { Space, Button, Card, Popconfirm, Layout, Table, Input } from "antd";
import { ALL_SERVICE, DELETE_SERVICE } from "../../constants/api";

function ServiceTable() {
  const { Content } = Layout;
  const [state, setState] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();

  useLayoutEffect(() => {
    getList();
  }, []);

  const getList = () => {
    setLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        const fetchedData = data["data"].map((row, index) => ({
          key: index,
          id: index + 1,
          name: row.name,
          price: row.price,
          gst: parseInt(row.gst_percent ?? 0) + "%",
          Action: (
            <Space>
              <Button
                onClick={() => {
                  navigate("/service/edit/" + row.id);
                }}
                block
              >
                Edit
              </Button>
              <Popconfirm
                title="Delete the task"
                description="Are you sure to delete this task?"
                onConfirm={() => deleteData(row.id)}
                okText="Yes"
                cancelText="No"
              >
                <Button danger>Delete</Button>
              </Popconfirm>
            </Space>
          ),
        }));
        setState(fetchedData);
        setFilteredData(fetchedData);
      } else {
        setState([]);
        setFilteredData([]);
        setLoading(false);
      }
    };

    const errorFn = function () {
      setState([]);
      setFilteredData([]);
      setLoading(false);
    };

    getAPI(ALL_SERVICE, successFn, errorFn, {});
  };

  const deleteData = (values) => {
    setLoading(true);
    let data = {
      id: values,
    };
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        getList();
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Delete Data");
    };
    postAPI(DELETE_SERVICE, data, successFn, errorFn);
  };

  const handleSearch = (value) => {
    setSearchText(value);

    const filtered = state.filter((data) =>
      data.name.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredData(filtered);
  };

  const columns = [
    {
      title: "Sno",
      dataIndex: "id",
      width: 50,
    },
    {
      title: "Name",
      dataIndex: "name",
      width: 150,
    },
    {
      title: "Price",
      dataIndex: "price",
      width: 150,
    },
    {
      title: "GST",
      dataIndex: "gst",
      width: 150,
    },
    {
      title: "Action",
      dataIndex: "Action",
      width: 100,
    },
  ];

  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Card
            title="Manage Services"
            extra={
              <Space>
                <Input
                  placeholder="Search by Name"
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                  style={{ width: 300 }}
                />
                <Button onClick={() => navigate("/service/add")}>
                  Add <PlusOutlined />
                </Button>
              </Space>
            }
            bordered={true}
          >
            <Table
              loading={loading}
              columns={columns}
              dataSource={filteredData}
              pagination={{ pageSize: 10 }}
              scroll={{ x: 240 }}
            />
          </Card>
        </Content>
        <LayoutFooter />
      </Layout>
    </>
  );
}

export default ServiceTable;
